const layout = {
  defaultContainerWidth: 1120,
}

export default layout
